// extracted by mini-css-extract-plugin
export default {"content":"Shadows_content__hNYwP","shadow1":"Shadows_shadow1__t70Tk","shadow2":"Shadows_shadow2__8DAJq"};